import { createAction } from 'redux-actions';

export const matchMedia = createAction('MATCH_MEDIA', media => ({ media }));

export const scrollWindow = createAction('SCROLL_WINDOW', pageYOffset => ({ pageYOffset }));

export const storePage = createAction('STORE_PAGE', page => ({ page }));

export const getCookies = createAction('GET_COOKIES', () => {
	const decodedCookie = decodeURIComponent(document.cookie);
	const cookieStrList = decodedCookie.split(';');

	const cookies = {};
	cookieStrList.forEach(cookieStr => {
		const [name, value] = cookieStr.trim().split('=');
		cookies[name] = value;
	});

	return { cookies };
});

export const acceptCookies = createAction('ACCEPT_COOKIES', () => {
	document.cookie = 'acceptCookies=y';
	return {
		cookies: {
			acceptCookies: 'y',
		},
	};
});



// WEBPACK FOOTER //
// ./src/actions/global.js